/**
 * 应用配置（运行时唯一入口）
 *
 * 思路与 user 项目 src/requests/env.js 完全一致：
 * 后端地址在运行时按“当前访问域名 document.domain”直接决定，前端直连该地址，
 * 靠后端 CORS 放行跨域。不使用 devServer 代理，也不依赖 .env 构建变量。
 *
 * 约定：业务代码不要散落硬编码 host。请求统一以 /api 开头（沿用 dev 期习惯），
 * main.js 会在运行时把开头的 /api 重写为 baseUrl + apiVersion（后端真实前缀是 /v6），
 * fetch 与 el-upload 的 XHR 都被覆盖。apiVersion 必须与后端 api/config/v6/rules.php 一致。
 */
let baseUrl

// 线上：admin(love-admin) 与 api(love-api) 分域名部署
const proAddress = 'https://love-api.wkuaidian.com'
// 本地：直连本机后端（XAMPP 站点根）
const localAddress = 'http://127.0.0.1'

const domain = document.domain

if (domain === 'localhost' || domain === '127.0.0.1') {
  baseUrl = localAddress
} else {
  baseUrl = proAddress
}

export default {
  // 后端服务器地址（运行时按域名决定）
  baseUrl,

  // 后端真实版本前缀（与 rules.php 的 v6/... 路由一致；前端写 /api，运行时重写成 /v6）
  apiVersion: '/v6'
}
